import { closeModal, openModal, unitsUpdate, unitsSingleData, unitsListing, uqcCreate, uqcListing, unitsCreate, unitsListingSimple } from '../../../../../redux/actions/action-creator';
import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import Form from '../../../../../components/Form/Form';
import MasterListFooter from '../../../../../components/Footer/Master_Footer/MasterListFooter';

const UnitView = ({ data_to_view, title, closeModal_sec }) => {
  const dispatch = useDispatch();
  const [load, setLoad] = useState(false)

  const { userData = null } = useSelector(state => state.auth);
  const initialState = {
    type: 'Simple',
    symbol: '',
    formal_name: '',
    unit_quantity_code: 'Not Applicable',
    uqc_id: 'Not Applicable',
    no_decimal_places: '0',
    first_unit: '',
    first_unit_id: '',
    conversion: '',
    second_unit: '',
    secound_unit_id: '',
    uqc_code_create_name: '',
    company_id: userData?.id,
    id: data_to_view?.id
  }
  const [data, setData] = useState(initialState);

  useEffect(() => {
    setLoad(true)
    dispatch(unitsSingleData(data_to_view)).then((response) => {
      console.log(response);
      if (response?.status) {
        setData({
          type: response.data?.type,
          symbol: response.data?.symbol,
          formal_name: response.data?.formal_name,
          unit_quantity_code: response.data?.uqc_name,
          uqc_id: response.data?.uqc_id,
          no_decimal_places: response.data?.no_decimal_places,
          first_unit: response.data?.first_unit_id,
          first_unit_id: response.data?.first_unit,
          conversion: response.data?.conversion,
          second_unit: response.data?.second_unit_id,
          secound_unit_id: response.data?.second_unit,
          uqc_code_create_name: '',
          company_id: userData?.id,
          id: data_to_view?.id
        })
        setLoad(false)
      }
      else {
        toast.warn(response?.message || 'Fail !', {
          position: toast.POSITION.TOP_CENTER
        });
      }
    }).catch(error => {
      console.log(error)
      toast.error(error?.Responsemessage || ' Failed!', {
        position: toast.POSITION.TOP_CENTER
      });
    })
  }, [])

  return (
    <Form
      title='Unit View'
      loading={load}
      col='col-7'
      Footer={MasterListFooter}
    >
      <div className='row p-0 ps-2 m-0 mb-1'>
        <div
          className="col-3 font_size p-0 m-0 ps-1 text-start fw-bold"
        >
          Name
        </div>
        <div
          className="col-1 font_size p-0 m-0 text-center fw-bold"
        >
          :
        </div>
        <div
          className={`col-8 font_size p-0 m-0 ps-1 text-start`}
        >
          {data?.formal_name}
        </div>
        <div className='border'></div>
        <div
          className="col-3 font_size p-0 m-0 ps-1 text-start fw-bold"
        >
          Type
        </div>
        <div
          className="col-1 font_size p-0 m-0 text-center fw-bold"
        >
          :
        </div>
        <div
          className={`col-8 font_size p-0 m-0 ps-1 text-start`}
        >
          {data?.type}
        </div>
        <div className='border'></div>
        <div
          className="col-3 font_size p-0 m-0 ps-1 text-start fw-bold"
        >
          Unit Name
        </div>
        <div
          className="col-1 font_size p-0 m-0 text-center fw-bold"
        >
          :
        </div>
        <div
          className={`col-8 font_size p-0 m-0 ps-1 text-start`}
        >
          {data?.symbol}
        </div>
        <div className='border'></div>
        <div
          className="col-3 font_size p-0 m-0 ps-1 text-start fw-bold"
        >
          Unit Quantity Code
        </div>
        <div
          className="col-1 font_size p-0 m-0 text-center fw-bold"
        >
          :
        </div>
        <div
          className={`col-8 font_size p-0 m-0 ps-1 text-start`}
        >
          {data?.unit_quantity_code}
        </div>
        <div className='border'></div>
        <div
          className="col-3 font_size p-0 m-0 ps-1 text-start fw-bold"
        >
          No. of Decimal Places
        </div>
        <div
          className="col-1 font_size p-0 m-0 text-center fw-bold"
        >
          :
        </div>
        <div
          className={`col-8 font_size p-0 m-0 ps-1 text-start`}
        >
          {data?.no_decimal_places}
        </div>
      </div>
    </Form>
  )
}

export default UnitView
